import http from '@/utils/http';
const base_path = '/v2/channelType';

/**
 * 渠道类型选择器
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const getChannelTypeSelectorListApi = (params) => {
  return http.get({
    url: `${base_path}/selector`,
    params,
  });
};
